// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DyNOpCGnC1WZgiD4GK7z{max-width:100%;display:grid;gap:8px}`, "",{"version":3,"sources":["webpack://./src/widgets/MessageCard/ui/OtherAttachmentContentContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,YAAA,CACA,OAAA","sourcesContent":[".wrap{\n  max-width: 100%;\n  display: grid;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `DyNOpCGnC1WZgiD4GK7z`
};
export default ___CSS_LOADER_EXPORT___;
